import { memo } from 'react';

import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';
import { SearchCommandVisualSearchDropzone } from '~/components/SearchCommand/SearchCommandVisualSearchDropzone';

export type SearchCommandSimilarImageSearchProps = {
  onSearch: (base64Image: string) => void;
};

export const SearchCommandSimilarImageSearch = memo(({ onSearch }: SearchCommandSimilarImageSearchProps) => {
  return (
    <SearchCommandGroup heading="Search by image">
      <SearchCommandVisualSearchDropzone onSearch={onSearch} />
    </SearchCommandGroup>
  );
});

SearchCommandSimilarImageSearch.displayName = 'SearchCommandSimilarImageSearch';
